import Vue from 'vue'

import {
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import PromotionModel from '@/models/PromotionModel'

import promotionService from '@/services/promotion.service'

// -----------------------------------------------------------------------------

const state = {
    isLoading: false,
    promotions: {},
}

const getters = {
    getPromotions: state => {
        return _orderBy(state.promotions, ['id'], ['asc'])
    },
}

const mutations = {
    setLoading(state, isLoading) {
        state.isLoading = !!isLoading
    },

    setPromotions(state, payload) {
        state.promotions = {}

        _forEach(payload, item => {
            const Promotion = new PromotionModel(item)

            Vue.set(state.promotions, Promotion.id, Promotion)
        })
    },

    setPromotion(state, payload) {
        const Promotion = new PromotionModel(payload)

        Vue.set(state.promotions, Promotion.id, Promotion)
    },
}

const actions = {
    async fetch({ commit }) {
        commit('setLoading', true)

        let response

        try {
            response = await promotionService.getList()

            commit('setPromotions', response.response.items)
            commit('setLoading', false)
        } catch (error) {
            commit('setLoading', false)
            return Promise.reject(error)
        }
    },

    async fetchById({ commit }, promotionId) {
        commit('setLoading', true)

        let response

        try {
            response = await promotionService.getById(promotionId)

            commit('setPromotion', response.response.promo)
            commit('setLoading', false)
        } catch (error) {
            commit('setLoading', false)
            return Promise.reject(error)
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
